module.exports = __webpack_public_path__ + "img/9H.3ac1dc84.svg";